/*
 * @Author: ningbo.kang
 * @Date: 2019-11-29 11:34:31
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-01-24 14:06:21
 * @FilePath: /fed-authority/src/router/frameOut.js
 * @Description: 描述
 */
import layout from '@/layouts/HeaderAsideLayout';
import loaded from '@/utils/util.import';
import dbUser from '@/api/system/user';

/**
 * 在主框架之外显示
 */
export default [
  // 登录
  {
    path: '/login',
    name: 'login',
    redirect: '/home',
    component: loaded('LoginNew'),
  },
  // 退出
  {
    path: '/logout',
    name: 'logout',
    hidden: true,
    component: loaded('system/function/logout'),
  },
  // 权限申请
  {
    path: '/authority/apply',
    name: 'apply',
    meta: {
      title: 'common.pageTitle.apply',
      keepAlive: false,
      // perms: ['authority:apply:view'],
    },
    component: loaded('Authority/apply'),
  },
  {
    path: '/exception',
    component: layout,
    meta: { title: '异常' },
    children: [
      // Exception
      {
        path: '/exception/403',
        meta: { title: '403页' },
        component: loaded('exception/403'),
      },
      {
        path: '/exception/404',
        meta: { title: '404页' },
        component: loaded('exception/404'),
      },
      {
        path: '/exception/500',
        meta: { title: '500页' },
        component: loaded('exception/500'),
      },
    ],
  },
  // 换取token，没有实质的页面
  {
    path: '/code2token',
    beforeEnter(to, from, next) {
      const { code, redirect = '/' } = to.query;
      dbUser
        .SSOCode2Token({
          code,
        })
        .then((res) => {
          // console.log(res);
          const { success } = res;
          // 此处逻辑根据业务系统自行调整
          if (success) {
            next({
              path: redirect,
              replace: true,
            });
          } else {
            window.history.go(-1);
          }
        })
        .catch(() => {
          window.history.go(-1);
        });
    },
  },
];
